import { CommandBase } from "../CommandBase.js";

export class ProjectsCommand extends CommandBase {
    async execute(args) {
        this.write("ACTIVE PROJECTS DATABASE:", "text-accent");
        this.write("Run 'ls projects' to view file list.", "text-muted");
        this.writeHTML(`<div class="terminal-spacer">&nbsp;</div>`);
        
        const projects = this.contentManager.getProjects();
        if (!projects || projects.length === 0) {
            this.write("No projects found in database.", "text-danger");
            return;
        }

        projects.forEach(proj => {
            let statusClass = 'text-muted';
            if (proj.status === 'active' || proj.status === 'completed') statusClass = 'text-success';
            if (proj.status === 'in-progress') statusClass = 'text-warning';

            const html = `
                <div class="terminal-list-item">
                    <div class="terminal-list-header">
                        <strong class="text-primary">${proj.title}</strong>
                        <span class="${statusClass}">[${proj.status.toUpperCase()}]</span>
                    </div>
                    <div class="text-muted terminal-indent">${proj.excerpt}</div>
                    <div class="terminal-indent small dimmed">
                        <span class="text-muted">Technologies:</span> <span class="text-accent">${proj.tags ? proj.tags.join(', ') : 'N/A'}</span>
                    </div>
                    <div class="terminal-indent small text-muted-dim">
                        ID: ${proj.id}
                    </div>
                </div>
            `;
            this.writeHTML(html);
        });
        
        // ✅ SMARTER INSTRUCTIONS
        const currentDir = this.fileSystem.getCurrentDirectory();
        const projectsPath = '/home/user/projects';

        this.writeHTML(`<div class="terminal-spacer">&nbsp;</div>`);
        this.write("⚠ Files are located in the project directory.", "text-warning");
        this.write("To interact, run:", "text-muted");
        
        if (currentDir === projectsPath) {
            this.write("  ls", "text-accent");
        } else {
            this.write(`  cd ${projectsPath}`, "text-accent");
            this.write("  ls", "text-accent");
        }
        this.write("  cat [file]", "text-accent");
        }
}